module.exports = __webpack_public_path__ + "static/opentable-tc-setup.a8a4b32c.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/opentable-tc-setup.png
// module id = ./src/pages/opentable-tc-setup.png
// module chunks = 199769300672215